import { Component, OnInit } from '@angular/core';
import { UserService } from '../../../shared/user.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ErrorHandler } from '../../../shared/ErrorHandler';

@Component({
  selector: 'app-unify-marketing-grid',
  templateUrl: './unify-marketing-grid.component.html',
  styleUrls: ['./unify-marketing-grid.component.css']
})
export class UnifyMarketingGridComponent implements OnInit {
  
  prospects;
  Proj:any={};
  constructor(private userService: UserService,private route: ActivatedRoute,private router: Router, private errorHandler:ErrorHandler) { }

  ngOnInit() {
    this.GetAllProspect()
  }
  GetAllProspect() {
    
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.GetAllProspectsforMarketing()
      .subscribe(
        (data:any) => {
          this.prospects = data;
          // this.totalItems=data.TotalItemsCount;
          // this.itemsPerPage = itemsPerPage;
          // this.currentPage = pageNo;
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }
}



// WEBPACK FOOTER //
// ./src/app/prospect/unify-marketing/unify-marketing-grid/unify-marketing-grid.component.ts